<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listOrgSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="orgCodeInput.options"
          :data="orgCodeInput.data"
          :listener="orgCodeInput.listener"
        />
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="orgNameInput.options"
          :data="orgNameInput.data"
          :listener="orgNameInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/administrator/managed-org-add.html')"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listOrgSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #enabled="{item}">
            <td>
                <span v-if="item.enabled == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Vô hiệu hóa'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_enabled', item.id, item.orgName, item.enabled)"
              />
              </span>
              <span v-else class="dot-custom dot-danger">
                Vô hiệu hóa
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Hoạt động'"
                            v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_enabled', item.id, item.orgName, item.enabled)"/>
              </span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`/administrator/${item.id}/managed-org.html`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="
                    setupSelectOneAction('delete_one', item.id, item.orgName)
                  "
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "OrgList",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/organization/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "đơn vị",
          that.actionData.model.orgSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.orgSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listOrgSelectedId = [];
        that.showSuccessMsg({message: "Xóa đơn vị " + that.actionData.model.orgSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/organization/delete-list",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các đơn vị", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listOrgSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listOrgSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách đơn vị thành công"});
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("update_enabled", {
      url: "/organization/update-enable",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.orgIsEnable == true ? "vô hiệu hóa" : "hoạt động", "đơn vị", that.actionData.model.orgSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.orgSelectedId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.orgIsEnable == true ? "Vô hiệu hóa đơn vị thành công" : "Hoạt động đơn vị thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          orgSelectedId: null,
          orgSelectedName: null,
          orgIsEnable: null,
          listOrgSelectedId: []
        }
      },
      orgNameInput: {
        options: {
          placeholder: "Tên đơn vị",
          label: 'Tên đơn vị'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      orgCodeInput: {
        options: {
          placeholder: "Mã đơn vị",
          label: 'Mã đơn vị'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "code", label: "Mã đơn vị"},
            {key: "name", label: "Tên đơn vị"},
            {key: "enabled", label: "Trạng thái"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "enabled", "createDate",  "action"],
        },
        dataSource: {
          url: "/organization/page",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      let listOrgSelectedId = this.actionData.model.listOrgSelectedId;
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listOrgSelectedId = [];

        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listOrgSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listOrgSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, orgSelectedId, orgSelectedName, orgIsEnable) {
      let actionData = this.actionData.model;
      actionData.orgSelectedId = orgSelectedId || null;
      actionData.orgSelectedName = orgSelectedName || null;
      actionData.orgIsEnable = orgIsEnable || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    // setupSelectMoreAction: function (actionTypeKey) {
    //   this.$refs.actionModal.setCurrAction(actionTypeKey);
    // }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listOrgSelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
